const headerStyle = () => {
    return {
        borderColor: '#a81933'
    };
};

export const columns = [
    {
        dataField: 'name',
        text: 'Name',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'category',
        text: 'Category',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'numberOfQuestions',
        text: 'Number of Questions',
        sort: true,
        headerStyle: headerStyle
    }
];

export const sorting = [{
    dataField: 'name',
    order: 'desc'
}];